<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import axiosApiClient from '@/axios';
import { useLocaleStore } from '@/stores/locale';
import Swippy from '@/components/Swippy.vue';
const id = useRoute().params.id;

const localeStore = useLocaleStore();
interface Document {
  id: number;
  file_name: string;
  file_content: string;
  file_type: string;
  file_size: number;
  file_extension: string;
  file_path: string;
  file_url: string;
  file_description: string;
  created_at: string;
  updated_at: string;
}
interface Unit {
  id: number;
  name: string;
  description: string;
  project_id: number;
  type: string;
  status: string;
  cost: number;
  space: number;
  thumbnail: string | null;
}
interface Project {
  id: number;
  name: string;
  description: string;
  address: string;
  status: string;
  cost: number;
  duration: number;
  duration_unit: string;
  ingredients: string;
  end_date?: string;
  start_date?: string;
  owner?: string;
  type?: string;
  category?: string;
  project_manager?: string;
  space?: number;
  buildings?: number;
  units?: Unit[];
  sold_units?: number;
  available_units?: number;
  thumbnail?: string;
  gallery?: Document[];
  created_at?: string;
  updated_at?: string;
}

const project = ref<Project>();
const projectInfo = ref<Project>();

const fetchProjectDetails = async () => {
  const response = await axiosApiClient.get('/api/projects/' + id);
  project.value = response.data;
  projectInfo.value = response.data.project;
};
onMounted(() => {
  fetchProjectDetails();

});
</script>
<template>
  <app-layout>
    <div class="flex flex-col p-4" :dir="localeStore.locale == 'ar' ? 'rtl' : 'ltr'">
      <div class="flex gap-3 items-center w-full" v-if="projectInfo?.thumbnail">
        <div class="flex flex-col items-center w-50">
          <img :src="'data:image/png;base64,' + projectInfo?.thumbnail" width="200" height="300" alt=""
            class="border rounded-md p-2" />
          <small>{{ projectInfo?.address }}</small>
        </div>
        <div class="flex flex-col items-start w-100">
          <h2>{{ projectInfo?.name }}</h2>
          <div v-if="projectInfo" class="flex gap-3 items-center border rounded-md w-50 bg-yellow-500 p-2 mt-3">
            <h4>{{ $localeT('Units Count') }}</h4>
            <h3>{{ projectInfo?.units?.length }}</h3>
          </div>
        </div>
      </div>
      <div class="flex mt-3 text-center w-full gap-2">
        <Swippy :images="project?.gallery" />
      </div>
    </div>
  </app-layout>
</template>

<style lang="scss" scoped>
span>p {
  color: #000 !important;
}

.imgg {
  img {
    height: 70vh;
    min-width: 100vw;
  }
}
</style>
